import React from 'react';
import { REPORT } from '../print/PrintAtoms';
import type { ResolveItem } from '../../lib/parcel-analysis';

// `milestone` names the deal step these items gate. Defaults to "LOI"; the Crown
// Pine A1 briefing passes "terms" because that page must not print the word LOI.
export const ResolveBeforeLOI: React.FC<{ items: ResolveItem[]; milestone?: string }> = ({ items, milestone = 'LOI' }) => {
  if (items.length === 0) return null;

  const title = items.length === 1 ? `Confirm before ${milestone}` : `Resolve before ${milestone}`;

  return (
    <div style={{
      border: `1.5px solid ${REPORT.caution}`, borderRadius: '6px',
      padding: '14px 16px', background: 'rgba(154,123,48,0.04)',
    }}>
      <div style={{
        fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', color: REPORT.caution,
        textTransform: 'uppercase', fontFamily: 'monospace', marginBottom: '8px',
      }}>
        {'\u26A0'} {title}
      </div>
      {items.map((item, i) => (
        <div key={i} style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
          padding: '5px 0',
          borderBottom: i < items.length - 1 ? '1px solid rgba(154,123,48,0.12)' : 'none',
        }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '11px', fontWeight: 600, color: REPORT.heading }}>{item.what}</div>
            <div style={{ fontSize: '9.5px', color: REPORT.secondary, marginTop: '1px' }}>{item.why}</div>
          </div>
          <div style={{ marginLeft: '16px', textAlign: 'right', flexShrink: 0 }}>
            <div style={{ fontSize: '10px', color: REPORT.caution, fontWeight: 600 }}>{item.cost}</div>
            <div style={{ fontSize: '9px', color: REPORT.secondary }}>{item.timeline}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
